export const TileViewerConstants = {
    INIT_TILE_VIEWER_STATE: "INIT_TILE_VIEWER_STATE", 
    UPDATE_TILE_VIEWER_STATE: "UPDATE_TILE_VIEWER_STATE", 
    UPDATE_TILE_VIEWER_APP_CLOSED_STATE: "UPDATE_TILE_VIEWER_APP_CLOSED_STATE", 
    UPDATE_TILE_VIEWER_APP_POSITION: "UPDATE_TILE_VIEWER_APP_POSITION", 
    UPDATE_TILE_VIEWER_APP_CLICK_TIME: "UPDATE_TILE_VIEWER_APP_CLICK_TIME", 
    UPDATE_SHAPE: "UPDATE_SHAPE", 
    UPDATE_IS_DRAWING: "UPDATE_IS_DRAWING"
} 